import axios from "axios";

export const employeesImporter = async (employees) => {
  const url = window.location.hostname.includes('localhost')  ? 'localhost' : 'unioninformatica.org';debugger
  const config = {
    method: "POST",
    url: `http://${url}:4000/api/v1/boletaDigital/importEmployees`,
    //url: "http://localhost:4000/api/v1/boletaDigital/importEmployees",
    headers: {
      "Content-Type": "application/json",
    },
    data: employees,
  };

  try {
    const response = axios(config);
    return await response;
  } catch (error) {
    const { response } = error;
    return await response;
  }
};


